/*
 * Description:
 * ---------------------
 * The organisation the Approvers and Agent Rules screens show. The server
 * answers for one organisation at a time (?customer=); a person who sees
 * more than one picks it here, the first by default. Until /domains answers,
 * domains is null. none says the person sees no organisation at all; when
 * /domains does not answer, the customer stays empty and the server answers
 * for the first the person sees.
 *
 * ! file components/CustomerPick.js
 */
import React, { useEffect, useState } from "react";
import { ROUTES, ask } from "./approvalApi";
import { CUSTOMER } from "./approvalWords";

export function useCustomer(serverApiUrl) {
  const [domains, setDomains] = useState(null);
  const [none, setNone] = useState(false);
  const [customer, setCustomer] = useState("");
  useEffect(() => {
    let live = true;
    ask(serverApiUrl, ROUTES.domains)
      .then((d) => {
        if (!live) return;
        const list = d.domains || [];
        setDomains(list);
        setNone(list.length === 0);
        setCustomer((c) => c || list[0]?.id || "");
      })
      .catch(() => live && setDomains([]));
    return () => { live = false; };
  }, [serverApiUrl]);
  return { domains, none, customer, setCustomer, name: domains?.find((d) => d.id === customer)?.name || "" };
}

export default function CustomerPick({ domains, customer, setCustomer }) {
  if (!domains || domains.length < 2) return null;
  return (
    <label className="ap-pick">
      <span>{CUSTOMER}</span>
      <select className="fw-input" value={customer} onChange={(e) => setCustomer(e.target.value)}>
        {domains.map((d) => <option key={d.id} value={d.id}>{d.name || d.id}</option>)}
      </select>
    </label>
  );
}
